module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/cloud-upload-c1f4c8f5c7f5e32a3b5fc6e881b0e369.svg";